import {createMuiTheme, responsiveFontSizes} from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

export default responsiveFontSizes(
	createMuiTheme({
		palette: {
			type: 'light',
			primary: blue,
		},
	}),
);
